import update from 'immutability-helper'

import * as actions from '../../actions/actions'

const initialState = {
  bankToEdit: {
    bankId: '',
    bankName: '',
    bankContact: '',
    enabled: false,
    corporates: [],
    bankImage:'',
    primaryColor:'',
    secondaryColor:''
  },
  error: '',
  isModalOpen:false
}

export default function bankEdit(state = initialState, action) {
  switch (action.type) {
    case actions.FETCH_BANK_EDIT_SUCCESS:
      return fetchBankEditSuccess(state, action)
    case actions.FETCH_BANK_EDIT_FAILURE:
      return fetchBankEditFailure(state, action)
    case actions.EDIT_BANK_BANK_CONTACT_FIELD_CHANGE:
      return editBankContactFieldChange(state, action)
    case actions.EDIT_BANK_ENABLED_FIELD_CHANGE:
      return editBankEnabledFieldChange(state, action)
    case actions.EDIT_BANK_CORPORATE_FIELD_CHANGE:
      return editBankCorporateFieldChange(state, action)
    case actions.EDIT_BANK_IMAGE_UPLOAD:
      return editBankImageChange(state,action)
    case actions.BANK_PRIMARY_COLOR_CHANGE:
      return editBankPrimaryColorChange(state,action)
    case actions.BANK_SECONDARY_COLOR_CHANGE:
      return editBankSecondaryColorChange(state,action)
    case actions.EDIT_BANK_CLEAN:
      return editBankClean(state, action)
    case actions.UPDATE_BANK_EDIT_FAILURE:
      return UpdateBankEditError(state,action)
    default:
      return state
  }
}


const UpdateBankEditError = (state,action) => {
  return {
    ...state,
    error: action.error
  }
}

const fetchBankEditSuccess = (state, action) => {
  return {
    ...state,
    bankToEdit: action.value
  }
}

const fetchBankEditFailure = (state, action) => {
  return {
    ...state,
    error: action.error
  }
}

const editBankContactFieldChange = (state, action) => {
  return update(
    state,
    {bankToEdit: {bankContact: {$set: action.value}}}
    )
}

const editBankEnabledFieldChange = (state, action) => {
  return update(
    state,
    {bankToEdit: {enabled: {$set: action.value}}}
  )
}

const editBankCorporateFieldChange = (state, action) => {
  return update(
    state,
    {bankToEdit: {corporates: {$set: action.value}}}
  )
}

const editBankImageChange = (state, action) => {
  return update(
      state,
      {bankToEdit: {bankImage: {$set: action.value}}}
  )
}

const editBankPrimaryColorChange = (state, action) => {
  return update(
      state,
      {bankToEdit: {primaryColor: {$set: action.value}}}
  )
}

const editBankSecondaryColorChange = (state, action) => {
  return update(
      state,
      {bankToEdit: {secondaryColor: {$set: action.value}}}
  )
}

const editBankClean = (state, action) => {
  return initialState;
}